// `window.ReactNativeWebView` is injected by react-native-webview (the
// inkle-mobile app's WebView wrapper) and is only present when this page is
// running inside it — there's no other reliable way to detect this, since
// the mobile WebView otherwise presents a normal browser environment.
export function isInkleMobileApp(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof (window as { ReactNativeWebView?: unknown }).ReactNativeWebView !==
      "undefined"
  );
}
